// =================================================================================================
// Mona Core API
// The version of the OpenAPI document: https://core.qa240.stage.monatest.icu/auto-open-api-spec.yaml 1.6.65
// Contact: https://www.clinomic.biz
//
// NOTE: This class is auto generated at 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
// by OpenAPI Generator https://openapi-generator.tech
// Do not edit the class manually.
// =================================================================================================

import camelcaseKeys from 'camelcase-keys';
import { instanceToPlain, plainToInstance, Type, Transform } from 'class-transformer';
import snakecaseKeys, { SnakeCaseKeys } from 'snakecase-keys';
import { TransformDate } from '../helpers';

/**
 * Serializes Report Type from database.
 * @see #/components/schemas/ReportType - reference to schema in open-api-spec.yaml
 * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
 * @version 1.6.65
 *
 * NOTE: This class is auto generated by OpenAPI Generator
 * Do not edit this manually.
 */
export interface ReportType {
    /**
     * The Report Type Id
     * @dataFormat uuid
     */
    readonly id: string;
    /**
     * The report type
     *
     */
    report_type: string;
    /**
     * The name of report type
     *
     */
    name?: string | null;
    /**
     * The display name of report type
     *
     */
    display_name?: string | null;
}
// -----------------------------------------------------------------------------
// Frontend Model
// NOTE: This class is auto generated by OpenAPI Generator
// Do not edit the class manually.
// -----------------------------------------------------------------------------

/**
 * Namespace that holds Frontend models/classes for ReportType
 */
export namespace ReportType {
    /**
     * ReportType Frontend Model with camelCase properties
     * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
     * @version 1.6.65
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class Model {
        /**
         * The Report Type Id
         * @dataFormat uuid
         */
        readonly id: string;
        /**
         * The report type
         * @type string (`dataFormat` is missing)
         */
        reportType: string;
        /**
         * The name of report type
         * @type string (`dataFormat` is missing)
         */
        name?: string | null;
        /**
         * The display name of report type
         * @type string (`dataFormat` is missing)
         */
        displayName?: string | null;

        /** @hideconstructor */
        constructor(obj: Model) {
            Object.assign(this, camelcaseKeys(obj, { deep: true }));
        }
    }
    /**
     * ReportType DTO
     * Transforms ReportType model from/to API object
     * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
     * @version 1.6.65
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class DTO {
        /** Transforms to Frontend ReportType model */
        static toModel(obj: ReportType): Model {
            const newObj = camelcaseKeys(obj, { deep: true });
            return plainToInstance(Model, newObj);
        }
        /** Transforms to Backend ReportType model */
        static toApi(obj: Model): ReportType {
            const newObj = instanceToPlain(plainToInstance(Model, obj)) as ReportType;
            return snakecaseKeys(newObj, { deep: true });
        }
    }
}
